import QuestionFillinchinese from './view';

export default QuestionFillinchinese;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/fillinchinese/index.js